import { SHOWCASE_WORKSPACE_ID } from '@/demo/showcaseCatalog';
import type { WorkspaceRecord } from '@/lib/auth/workspaceAuthority';

/**
 * Demo workspace catalog for the disconnected environment.
 *
 * The runtime demo intentionally contains exactly ONE workspace. Multi-workspace
 * branching is exercised by synthetic test fixtures, NOT by fabricating a second
 * runtime portfolio here. In production this is replaced by an authenticated
 * workspace lookup; the resolver contract (route id -> record | null) is stable.
 */
export const SHOWCASE_ORGANIZATION_ID = 'ax1-showcase-organization';

const DEMO_WORKSPACES: Record<string, WorkspaceRecord> = {
  [SHOWCASE_WORKSPACE_ID]: {
    id: SHOWCASE_WORKSPACE_ID,
    organizationId: SHOWCASE_ORGANIZATION_ID,
    status: 'active',
  },
};

/** Route id -> workspace record, or null when unknown. */
export function lookupDemoWorkspace(workspaceId: string): WorkspaceRecord | null {
  return DEMO_WORKSPACES[workspaceId] ?? null;
}
